const KEYCODE_ESC = 27;

document.addEventListener('click', function handleClickOutsideBox(event) {
  const filterBarItemsChecked = document.querySelectorAll(".filter_bar__item__checkbox.checked");

  filterBarItemsChecked && filterBarItemsChecked.forEach(item => {
    const itemParent = item.parentNode;
    const eventTarget = event.target;

    if (!itemParent.contains(eventTarget)) {
      itemParent.querySelector(":scope > .filter_bar__item__label").click();
      return;
    }
  });
});

document.addEventListener('keydown', function handleEscape(event) {
  if (event.key === "Escape" || event.keyCode === KEYCODE_ESC) {
    const filterBarItemsChecked = document.querySelectorAll(".filter_bar__item__checkbox.checked");

    if (filterBarItemsChecked) {
      const last = filterBarItemsChecked.length - 1;
      filterBarItemsChecked[last].parentNode.querySelector(":scope > .filter_bar__item__label").click();
    }
  }
});
